// extracted by mini-css-extract-plugin
export default {"score-over-time-error":"styles_score-over-time-error__5DdHD"};